export default function ComparisonSection() {
  return (
    <section className="relative bg-foreground-900 py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-primary-400 blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-80 h-80 rounded-full bg-accent-400 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
            <div className="lg:w-1/2">
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/20 text-accent-300 text-xs font-semibold uppercase tracking-wider mb-6">
                / About
              </span>
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-white leading-tight">
                Why Our Pandabuy Spreadsheet Is Different
              </h2>
              <p className="mt-5 text-sm md:text-base text-foreground-200/80 leading-relaxed max-w-lg">
                Not all spreadsheets are created equal. We go beyond basic product lists with daily updates, seller verification, and comprehensive buying resources that help you shop with confidence.
              </p>

              <div className="mt-10 overflow-x-auto">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="border-b border-foreground-700/30">
                      <th className="py-3 pr-4 text-sm font-semibold text-white">Feature</th>
                      <th className="py-3 px-4 text-sm font-semibold text-primary-400">Our Spreadsheet</th>
                      <th className="py-3 pl-4 text-sm font-semibold text-foreground-400">Other Lists</th>
                    </tr>
                  </thead>
                  <tbody className="text-sm">
                    {[
                      ['Daily Updates', 'Yes', 'Partial'],
                      ['Seller Verification', 'Yes', 'No'],
                      ['QC Guides', 'Yes', 'No'],
                      ['Buying Tutorials', 'Yes', 'Limited'],
                      ['Safety Tips', 'Yes', 'No'],
                      ['14 Categories', 'Yes', 'Few'],
                    ].map((row, i) => (
                      <tr key={i} className="border-b border-foreground-700/20">
                        <td className="py-3 pr-4 text-foreground-200 font-medium">{row[0]}</td>
                        <td className="py-3 px-4 text-primary-400 font-semibold">
                          <span className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-check-line text-sm"></i>
                          </span>
                        </td>
                        <td className="py-3 pl-4 text-foreground-500">{row[2]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="lg:w-1/2 flex flex-col items-center lg:items-start">
              <div className="relative w-full max-w-md">
                <img
                  src="https://readdy.ai/api/search-image?query=Creative%20fashion%20research%20mood%20board%20overhead%20composition%20with%20curated%20fabric%20swatches%20product%20specification%20cards%20handwritten%20style%20notes%20and%20color%20palette%20references%20scattered%20across%20warm%20light%20oak%20wooden%20tabletop%20natural%20morning%20daylight%20streaming%20through%20window%20soft%20focus%20background%20authentic%20creative%20direction%20editorial%20workspace%20aesthetic&width=800&height=800&seq=compare-img-v2-xe93&orientation=squarish"
                  alt="Pandabuy Spreadsheet comparison and features overview"
                  title="Why Our Pandabuy Spreadsheet Is Different – Feature Comparison"
                  className="w-full rounded-lg object-cover object-top"
                />
              </div>

              <div className="mt-8 text-center lg:text-left">
                <div className="text-6xl md:text-8xl font-heading font-bold text-white">
                  1000<span className="text-primary-400">+</span>
                </div>
                <p className="mt-3 text-sm text-foreground-300 leading-relaxed max-w-sm">
                  Verified products across all categories, with new finds added daily from trusted sellers worldwide.
                </p>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Explore All Products
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-sm"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}